<template>
  <b-card-actions noActions>
    <b-tabs content-class="mt-1">
      <b-tab title="Property Pin Section">
        <validation-observer ref="simpleRules" v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(validationForm)">
            <b-row>
              <b-col md="12">
                <b-tabs content-class="mt-1" v-if="langs.length > 0">
                  <b-tab v-for="(lang, key) in langs" :key="'tab-' + key" :title="lang.name">
                    <b-form-group>
                      <label>Property Pin ({{ lang.name }})</label>
                      <validation-provider
                        :name="`name-${lang.code}`"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-input
                          v-model="input.name[lang.code]"
                          placeholder="Property Pin"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group>
                      <label>Address ({{ lang.name }})</label>
                      <validation-provider
                        :name="`address-${lang.code}`"
                        v-slot="{ errors }"
                      >
                        <b-form-input
                          v-model="input.address[lang.code]"
                          :placeholder="`Address (${lang.code})`"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-row>
                      <b-col md="6">
                        <b-form-group>
                          <label>Meta Title ({{ lang.name }})</label>
                          <validation-provider
                            :name="`meta_title (${lang.code})`"
                            v-slot="{ errors }"
                          >
                            <b-form-input
                              v-model="input.meta.meta_title[lang.code]"
                              :placeholder="`Meta Title (${lang.code})`"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      
                      <b-col md="6">
                        <b-form-group>
                          <label>Meta Description ({{ lang.name }})</label>
                          <validation-provider
                            :name="`meta_description (${lang.code})`"
                            v-slot="{ errors }"
                          >
                            <b-form-input
                              v-model="input.meta.meta_description[lang.code]"
                              :placeholder="`Meta Description (${lang.code})`"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-col>

              <b-col md="12">
                <label>Youtube URL</label>
                <b-form-group>
                  <b-form-input
                    v-model="input.youtube"
                    :placeholder="`Youtube URL`"
                  />
                </b-form-group>
              </b-col>
              
              <b-col md="12" class="q-description">
                <b-form-group label="Description">
                  <quill-editor style="height: 150px" v-model="input.description" />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <h5>Property Info</h5>
                <hr />
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Developer</label>
                  <v-select
                    v-model="input.devlop_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :reduce="(option) => option.id"
                    :options="devs"
                  />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Property Type</label>
                    <v-select
                    v-model="input.type_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="types"
                  />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <label>Rating</label>
                <b-form-group>
                  <b-form-rating
                    id="rating-lg-no-border"
                    v-model="input.rating"
                    no-border
                    variant="warning"
                    size="lg"
                    inline
                  />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <label>Year</label>
                <b-form-group>
                  <validation-provider name="year" rules="integer" v-slot="{ errors }">
                    <b-form-input v-model="input.year" placeholder="Year" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Price per sqm.</label>
                  <validation-provider
                    #default="{ errors }"
                    name="price_sqm"
                  >
                    <b-form-input
                      v-model="input.price_sqm"
                      placeholder="Price per sqm."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Level</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="integer"
                    name="level"
                  >
                    <b-form-input
                      v-model="input.level"
                      placeholder="Level"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Total Building</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="integer"
                    name="building"
                  >
                    <b-form-input
                      v-model="input.total_building"
                      placeholder="Building"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Total Unit</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="integer"
                    name="unit"
                  >
                    <b-form-input
                      v-model="input.total_unit"
                      placeholder="Unit"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Tags</label>
                  <v-select
                    v-model="input.tags_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="tags.map((g) => ({
                      name: g.name[currentLocale],
                      id: g.id
                    }))"
                    label="name"
                    :reduce="tag => tag.id"
                    multiple
                  />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <label>Comment</label>
                  <b-form-textarea
                    v-model="input.comment"
                    id="comment"
                    placeholder="Comment"
                    rows="3"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <h5>Location</h5>
                <hr />
              </b-col>

              <!-- <b-col md="3">
                <b-form-group>
                  <label>BTS</label>
                  <v-select
                    v-model="input.bts_id"
                    :options="bts.map((g) => ({
                      name: g.name[currentLocale],
                      id: g.id
                    }))"
                    label="name"
                    :reduce="bts => bts.id"
                    multiple
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                </b-form-group>
              </b-col> -->

              <b-col md="6">
                <b-form-group>
                  <label>BTS</label>
                  <b-row no-gutters>
                    <b-col>
                      <label>Station</label>
                      <v-select
                        v-model="bts_id"
                        :options="bts.map((g) => ({
                          name: g.name[currentLocale],
                          id: g.id
                        }))"
                        label="name"
                        :reduce="bts => bts.id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      />
                    </b-col>
                    <b-col class="px-1">
                      <label>Distance (m.)</label>
                      <b-form-input
                        v-model="distanceBts"
                        placeholder="Distance(m.)"
                      />
                    </b-col>
                    <b-col class="px-1">
                      <label>Duration (min.)</label>
                      <b-form-input
                        v-model="durationBts"
                        placeholder="Duration(min.)"
                      />
                    </b-col>
                    <b-col cols="auto" class="d-flex align-items-end">
                      <b-button
                        variant="outline-primary"
                        @click="addBTS"
                      >
                        Add
                      </b-button>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-between mt-1" v-for="(bts,index) in input.btsData" :key="index">
                    <div class="text-left w-100">{{  getNameBTS(bts.transitId)  }}</div>
                    <div class="text-left w-100">{{  `${bts.distance} m.`  }}</div>
                    <div class="text-left w-100">{{  `${bts.duration} min.`  }}</div>
                    <div>
                      <b-badge
                        variant="danger"
                        @click="removeBTS(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                        />
                      </b-badge>
                    </div>
                  </div>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>MRT</label>
                  <b-row no-gutters>
                    <b-col>
                      <label>Station</label>
                      <v-select
                        v-model="mrt_id"
                        :options="mrt.map((g) => ({
                          name: g.name[currentLocale],
                          id: g.id
                        }))"
                        label="name"
                        :reduce="mrt => mrt.id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      />
                    </b-col>
                    <b-col class="px-1">
                      <label>Distance (m.)</label>
                      <b-form-input
                        v-model="distanceMrt"
                        placeholder="Distance(m.)"
                      />
                    </b-col>
                    <b-col class="px-1">
                      <label>Duration (min.)</label>
                      <b-form-input
                        v-model="durationMrt"
                        placeholder="Duration(min.)"
                      />
                    </b-col>
                    <b-col cols="auto" class="d-flex align-items-end">
                      <b-button
                        variant="outline-primary"
                        @click="addMRT"
                      >
                        Add
                      </b-button>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-between mt-1" v-for="(mrt,index) in input.mrtData" :key="index">
                    <div class="text-left w-100">{{  getNameMRT(mrt.transitId)  }}</div>
                    <div class="text-left w-100">{{  `${mrt.distance} m.`  }}</div>
                    <div class="text-left w-100">{{  `${mrt.duration} min.`  }}</div>
                    <div>
                      <b-badge
                        variant="danger"
                        @click="removeMRT(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                        />
                      </b-badge>
                    </div>
                  </div>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>Airport Link</label>
                  <b-row no-gutters>
                    <b-col>
                      <label>Station</label>
                      <v-select
                        v-model="airportlink_id"
                        :options="airportlink.map((g) => ({
                          name: g.name[currentLocale],
                          id: g.id
                        }))"
                        label="name"
                        :reduce="airportlink => airportlink.id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      />
                    </b-col>
                    <b-col class="px-1">
                      <label>Distance (m.)</label>
                      <b-form-input
                        v-model="distanceAirportlink"
                        placeholder="Distance(m.)"
                      />
                    </b-col>
                    <b-col class="px-1">
                      <label>Duration (min.)</label>
                      <b-form-input
                        v-model="durationAirportlink"
                        placeholder="Duration(min.)"
                      />
                    </b-col>
                    <b-col cols="auto" class="d-flex align-items-end">
                      <b-button
                        variant="outline-primary"
                        @click="addAirportlink"
                      >
                        Add
                      </b-button>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-between mt-1" v-for="(air,index) in input.airportlinkData" :key="index">
                    <div class="text-left w-100">{{  getNameAirportlink(air.transitId)  }}</div>
                    <div class="text-left w-100">{{  `${air.distance} m.`  }}</div>
                    <div class="text-left w-100">{{  `${air.duration} min.`  }}</div>
                    <div>
                      <b-badge
                        variant="danger"
                        @click="removeAirportlink(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                        />
                      </b-badge>
                    </div>
                  </div>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>Zone</label>
                  <v-select
                    v-model="input.zone_id"
                    :options="zone.map((g) => ({
                      name: g.name[currentLocale],
                      id: g.id
                    }))"
                    label="name"
                    :reduce="zone => zone.id"
                    multiple
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                </b-form-group>
              </b-col>

              <!-- <b-row> -->
                <b-col md="3">
                  <b-form-group label="Province">
                    <v-select
                      v-model="input.province_id"
                      :options="provinceOptions"
                      :reduce="p => p.id"
                      label="name"
                      placeholder="Select a province"
                      @input="onProvinceChange"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group label="Amphure">
                    <v-select
                      v-model="input.amphure_id"
                      :options="amphureOptions"
                      :reduce="a => a.id"
                      label="name"
                      placeholder="Select an amphure"
                      @input="onAmphureChange"
                      :disabled="!input.province_id"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group label="District">
                    <v-select
                      v-model="input.tambon_id"
                      :options="tambonOptions"
                      :reduce="t => t.id"
                      label="name"
                      placeholder="Select a tambon"
                      @input="onTambonChange"
                      :disabled="!input.amphure_id"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="3">
                  <b-form-group label="Zip Code">
                    <b-form-input :value="input.zip_code" readonly />
                  </b-form-group>
                </b-col>
              <!-- </b-row> -->
              
              <b-col md="12">
                <h5>Map</h5>
                <hr />
              </b-col>

              <b-col md="6">
                <l-map :zoom="zoom" :center="center">
                  <l-tile-layer :url="url" />
                  <l-marker :lat-lng="markerLatLng" />
                  <l-circle
                    :lat-lng="circle.center"
                    :radius="circle.radius"
                    :color="circle.color"
                  />
                  <l-polygon
                    :lat-lngs="polygon.latlngs"
                    :color="polygon.color"
                  />
                </l-map>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>Lattitude</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="lat"
                  >
                    <b-form-input
                      v-model="input.lat"
                      @change="changelatlon"
                      placeholder="Lattitude"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <label>Longitude</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="lon"
                  >
                    <b-form-input
                      v-model="input.lon"
                      @change="changelatlon"
                      placeholder="Longitude"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- โซน / สถานี / ที่อยู่ คำนวณจากพิกัดได้ ไม่ต้องกรอกเอง -->
                <b-form-group>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="!hasCoord || isGeoLoading"
                    @click="checkCoord(false)"
                  >
                    <b-spinner v-if="isGeoLoading" small class="mr-25" />
                    ตรวจจากพิกัด
                  </b-button>
                  <div class="text-muted mt-25">
                    <small>
                      {{ hasCoord
                        ? 'ดูโซน, BTS/MRT/ARL และที่อยู่ที่คำนวณจากพิกัดนี้ ก่อนเลือกว่าจะใช้ไหม'
                        : 'ใส่ Latitude และ Longitude ก่อน จึงจะตรวจได้' }}
                    </small>
                  </div>
                </b-form-group>

                <geo-preview-modal
                  :visible.sync="isGeoModalVisible"
                  :preview="geoPreview"
                  :before-save="geoBeforeSave"
                  @apply="applyGeoPreview"
                  @skip="onGeoSkip"
                  @cancel="cancelGeoPreview"
                />
              </b-col>

              <b-col md="12">
                <hr />
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>Responsible By </label>
                  <vue-autosuggest
                    ref="autocomplete"
                    v-model="created_by"
                    :suggestions="suggestionscb"
                    :input-props="inputProps"
                    :section-configs="sectionConfigs"
                    :render-suggestion="renderSuggestioncb"
                    :get-suggestion-value="getSuggestionValuecb"
                    @input="fetchResultscb"
                  />    
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Active">
                  <b-form-checkbox
                    v-model="input.is_active"
                    switch
                    class="custom-control-primary"
                  >
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              
              <b-col md="12">
                <h5>Facility</h5>
                <hr />
              </b-col>

              <b-col md="12">
                <b-form-group>
                  <div class="facility-checkbox-grid">
                    <b-form-checkbox
                      v-for="facility in facilityOptions"
                      :key="facility.value"
                      v-model="input.facility_id"
                      :value="facility.value"
                      name="facility_id"
                      class="facility-checkbox-item"
                    >
                      <img
                        v-if="facility.icon"
                        :src="facility.icon"
                        class="facility-icon"
                        alt=""
                      />
                      {{ facility.text }}
                    </b-form-checkbox>
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-button variant="primary" type="submit" :disabled="isSubmitting">
                  <b-spinner v-if="isSubmitting" small class="mr-50" />Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-tab>

      <b-tab title="Upload Facility Images" v-if="id">
        <facility-upload />
      </b-tab>

      <b-tab title="FAQ" v-if="id">
        <pin-faq />
      </b-tab>
    </b-tabs>
  </b-card-actions>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton,BFormTextarea,BFormRating,BFormCheckbox,BFormCheckboxGroup,
  BTab, BTabs, BInputGroup, BBadge, BCard, BSpinner,
} from 'bootstrap-vue'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'
import { MIN_USER_KEYWORD, searchUsers } from '@core/utils/user-autocomplete'
/* eslint-disable global-require */
import {
  LMap, LTileLayer, LMarker, LCircle, LPolygon,
} from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'


//import Multiselect from 'vue-bootstrap-multiselect';

//popup
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import GeoPreviewModal from './GeoPreviewModal.vue'
import { ref, onUnmounted } from "@vue/composition-api";

// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import router from '@/router'
import { quillEditor } from 'vue-quill-editor'
import languagesStoreModule from '../../languages/languagesStoreModule'
import store from "@/store";
import PinFaq from '../pin-faq/pinFaq.vue'
import FacilityUpload from '../pin-upload/facilityUpload.vue'
const userData = JSON.parse(localStorage.getItem('userData'));

export default {
  components: {
    GeoPreviewModal,
    BCardActions,
    VueAutosuggest,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormTextarea,
    BFormRating,
    vSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BSpinner,
    LMap,
    LTileLayer,
    LMarker,
    LCircle,
    LPolygon,
    quillEditor,
    BTab, 
    BTabs,
    BInputGroup,
    BBadge,
    BCard,
    PinFaq,
    FacilityUpload,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
        isSubmitting: false,
        /*
         * popup "ตรวจจากพิกัด" — โซน/สถานี/ที่อยู่ คำนวณจากพิกัดบนเซิร์ฟเวอร์
         * (api: POST /place/v1/geo/preview-by-coord ใช้สูตรเดียวกับปุ่ม "คำนวณใหม่" ของ coord-review)
         * ไม่เติมให้เงียบ ๆ เพราะตำบลที่เดาจากเพื่อนบ้านผิดได้ราว 1 ใน 5 — กางให้เลือกก่อน
         */
        geoPreview: null,
        isGeoModalVisible: false,
        isGeoLoading: false,
        /* true = popup ถูกเปิดจากปุ่มบันทึก กด "ใช้ค่านี้" แล้วต้องบันทึกต่อเลย */
        geoBeforeSave: false,
        id:router.currentRoute.params.id,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        zoom: 15,
        center: [47.313220, -1.319482],
        markerLatLng: [47.313220, -1.319482],
        circle: {
          center: [47.313220, -1.319482],
          radius: 4500,
          color: '#EA5455',
        },
        polygon: {
          //latlngs: [[47.2263299, -1.6222], [47.21024000000001, -1.6270065], [47.1969447, -1.6136169], [47.18527929999999, -1.6143036], [47.1794457, -1.6098404], [47.1775788, -1.5985107], [47.1676598, -1.5753365], [47.1593731, -1.5521622], [47.1593731, -1.5319061], [47.1722111, -1.5143967], [47.1960115, -1.4841843], [47.2095404, -1.4848709], [47.2291277, -1.4683914], [47.2533687, -1.5116501], [47.2577961, -1.5531921], [47.26828069, -1.5621185], [47.2657179, -1.589241], [47.2589612, -1.6204834], [47.237287, -1.6266632], [47.2263299, -1.6222]],
          color: '#7367F0',
        },

        devs:[],
        input:{
          lat:null,
          lon:null,
          devlop_id:null,
          type_id:null,
          name: {},
          description:null,
          rating:null,
          year:null,
          price_sqm:null,
          level:null,
          comment:null,
          bts_id:[],
          mrt_id:[],
          airportlink_id: [],
          zone_id:[],
          tags_id:[],
          bts_distance:null,
          mrt_distance:null,
          airportlink_distance:null,
          is_active:true,
          facility_id:[],
          created_by: userData.id,
          updated_by: userData.id,
          btsData: [],
          mrtData: [],
          airportlinkData: [],
          meta: {
            meta_title: {},
            meta_description: {}
          },
          address: {},
          province_id: null,
          amphure_id: null,
          tambon_id: null,
          zip_code: null,
          youtube: '',
          total_building: null,
          total_unit: null,
        },
        onSelected:null,
         type_id:null,
        created_by:null,
        devlop_id:null,
        
        suggestions: [],
        suggestionscb:[],
        types:[],
        bts:[],
       
        mrt:[],
       
        airportlink:[],
        
        zone:[],

        facilities:[],

        tags:[],
       
        inputProps: {
          id: 'autosuggest__input_ajax',
          placeholder: 'Developer',
          class: 'form-control',
          name: 'develop',
          
        },
        suggestionsType: [],
        inputPropsType: {
          id: 'autosuggest__input_ajax',
          placeholder: 'Responsible By',
          class: 'form-control',
          name: 'created_by',
          
        },
        sectionConfigs:{
          dev: {
       
            label: 'User',
            onSelected: selected => {
               this.input.devlop_id = selected.item.id;
            },
          },
          cb: {
       
            label: 'User',
            onSelected: selected => {
               this.input.created_by = selected.item.id;
            },
          },
          types: {
             label: 'Type',
            onSelected: selected => {
              // this.input.type_id = selected.item.id;
              //this.selected = selected.item
            },
          }
       
        },
        transitId: '', 
        distance: 0,

        bts_id: '',
        distanceBts: '',
        durationBts: '',

        mrt_id: '',
        distanceMrt: '',
        durationMrt: '',

        airportlink_id: '',
        distanceAirportlink: '',
        durationAirportlink: '',

        provinceOptions: [],
        amphureOptions: [],
        tambonOptions: [],
    }
  },
  computed: {
    hasCoord() {
      const lat = Number(this.input.lat)
      const lng = Number(this.input.lon)

      return Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0
    },
    currentLocale() {
      return this.$i18n.locale
    },
    facilityOptions() {
      const locale = this.currentLocale || 'en';
      return this.facilities
        .filter(facility => facility.is_active)
        .map(facility => ({
          text: facility.name[locale] || facility.name.en || 'Unnamed',
          value: facility.id,
          icon: facility.filename
        }));
    },
  },
  created() {
     
     if(this.id != undefined){
        this.getFacs();
        this.getData();
        this.getBts();
        this.getMrt();
        this.getZone();
        this.getAirport()
      }

      this.getDevelops();
       this.getTypes();
     axios.post('/transit/v1/lists', {
      type_code: "bts",
      is_active: 1,
     })
      .then(res => {
        this.bts = res.data.data;
      })
      axios.post('/transit/v1/lists', {
        type_code: "mrt",
        is_active: 1,
      })
      .then(res => {
        this.mrt = res.data.data; 
      })
      axios.post('/transit/v1/lists', {
        type_code: "airport",
        is_active: 1,
      })
      .then(res => {
        this.airportlink = res.data.data;
      })
      let queryParams1 = {
         perpage: 1000,
        offset:0
       
      }
     var data1 = JSON.stringify(queryParams1);
      axios.post('/zone/v1/lists', {
        is_active: 1,
      })
      .then(res => {
        this.zone = res.data.data;
      })
      axios.post('tags/v1/get', {
        perpage: 1000,
        offset: 0,
        is_active: 1,
      })
      .then(res => {
        this.tags = res.data.data;
      })
      let queryParams = {
        type_code:1,
        is_active: 1,
        order_by: "FIRST_LETTER ASC"
      }
     var data = JSON.stringify(queryParams);
      axios.post('facility/v1/lists', data)
      .then(res => {
        this.facilities = res.data.data; 
        
      })
      
      this.fetchProvinces()
      
  },
  methods: {
    /* คืน true เมื่อได้ผลมาแล้ว (popup เปิดให้เอง) */
    async checkCoord(beforeSave) {
      if (!this.hasCoord) {
        this.makeToast('danger', 'ต้องมีพิกัดก่อน', 'กรุณาใส่ Latitude และ Longitude ก่อนตรวจ')

        return false
      }

      this.isGeoLoading = true

      try {
        const res = await axios.post('place/v1/geo/preview-by-coord', {
          lat: this.input.lat,
          lng: this.input.lon,
        })

        this.geoPreview = res.data.data
        this.geoBeforeSave = !!beforeSave
        this.isGeoModalVisible = true

        return true
      } catch (error) {
        const message = error.response && error.response.data ? error.response.data.message : null

        this.makeToast('danger', 'ตรวจจากพิกัดไม่สำเร็จ', message || 'ลองใหม่อีกครั้ง')

        return false
      } finally {
        this.isGeoLoading = false
      }
    },

    /* ปิด popup โดยไม่ทำอะไร — ต้องล้างธง ไม่งั้นกดบันทึกครั้งถัดไปจะข้าม popup ไปเลย */
    cancelGeoPreview() {
      this.isGeoModalVisible = false
      this.geoBeforeSave = false
    },

    /** เอาผลที่คำนวณได้ใส่ฟอร์ม ตามหัวข้อที่ติ๊กไว้ — ยังไม่บันทึกลง DB */
    async applyGeoPreview(parts) {
      const preview = this.geoPreview

      if (!preview) return

      if (parts.zone) {
        this.input.zone_id = preview.zones.map(zone => zone.id)
      }

      if (parts.transit) {
        const rows = list => list.map(station => ({
          transitId: station.id,
          distance: station.distance,
          duration: station.duration,
        }))

        this.input.btsData = rows(preview.bts)
        this.input.mrtData = rows(preview.mrt)
        this.input.airportlinkData = rows(preview.airport)
      }

      if (parts.address && preview.admin_area) {
        const area = preview.admin_area

        this.input.province_id = area.province_id
        /* ต้องโหลดรายการอำเภอ/ตำบลก่อน ไม่งั้น select จะโชว์ค่าว่างทั้งที่ id ถูกแล้ว */
        await this.onProvinceChange(area.province_id)
        this.input.amphure_id = area.amphure_id
        await this.onAmphureChange(area.amphure_id)
        this.input.tambon_id = area.tambon_id
        this.input.zip_code = area.zip_code || null
      }

      this.isGeoModalVisible = false

      if (this.geoBeforeSave) this.saveForm()
    },

    /** "บันทึกตามที่กรอกเอง" — ไม่เอาค่าที่คำนวณ แต่บันทึกต่อ */
    onGeoSkip() {
      this.isGeoModalVisible = false
      this.saveForm()
    },

    async fetchProvinces() {
      const res = await axios.get("address/v1/provinces");
      this.provinceOptions = res?.data?.data.map((p) => ({
        id: p.id,
        name: this.currentLocale == "th" ? p.name_th : p.name_en,
      }));
    },
    async onProvinceChange(provinceId) {
      this.amphureOptions = [];
      this.tambonOptions = [];

      const res = await axios.get(`amphures/${provinceId}`);
      this.amphureOptions = res?.data?.data.map((a) => ({
        id: a.id,
        name: this.currentLocale == "th" ? a.name_th : a.name_en,
      }));
    },
    async onAmphureChange(amphureId) {
      this.tambonOptions = [];

      const res = await axios.get(`tambons/${amphureId}`);
      this.tambonOptions = res?.data?.data.map((t) => ({
        id: t.id,
        name: this.currentLocale == "th" ? t.name_th : t.name_en,
      }));
    },
    async onTambonChange(tambonId) {
      try {
        const res = await axios.get(`zipcode/${tambonId}`);
        const firstItem = res?.data?.data?.[0];
        this.input.zip_code = firstItem ? firstItem.zip_code : null;
        
      } catch (error) {
        console.error('Error fetching zip code:', error);
        this.input.zip_code = null;
      }
    },
    async getDevelops(){
      let params = {
        perpage: 500,
        offset:0,
        //type_code:'mrt',
        keyword:'',
      }
      var data = JSON.stringify(params);
      let devs = await axios.post('developer/v1/lists', data);
      if(devs.data.data){
        this.devs = devs.data.data; 
      }

    },
    async getBts(){
      const bts = await axios.get(`transit/v1/bts/${this.id}`);
      this.input.bts_id = bts?.data?.data
    },
    async getMrt() {
      const mrts = await axios.get(`transit/v1/mrt/${this.id}`);
      this.input.mrt_id = mrts?.data?.data
    },
    async getAirport(){
      const airports = await axios.get(`transit/v1/airport/${this.id}`);
      this.input.airportlink_id = airports?.data?.data
    },
    async getZone(){
      const zones = await axios.get(`transit/v1/zone/${this.id}`);
      this.input.zone_id = zones?.data?.data
    },
    async getTypes(){
            const types = await axios.get('place/v1/type');

          if(types.data.data){
             this.types = types.data.data;
          }
    },
    async getFacs(){
        let facs = await axios.get('place/v1/getfacilities/'+this.id);
        let fa = [];

        if(facs.data.data){
          facs.data.data.filter(item => {
            fa.push(item.facility_id);
          });
        }
        this.input.facility_id = fa;
    },
    async getData(){
     
      var place = await axios.get('place/v1/getdetail/'+this.id);
     
      if(!place.data.data.id){
        
        this.$router.push('/place/lists', () => {
            this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `ERror`,
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: `Data not Found.`,
                },
              })
          });


      }else{
          let pl = place.data.data
          this.input.name =  pl.name
          this.input.description =  pl.description
          this.input.lat = pl.lat;
          this.input.lon = pl.lng;
          this.input.year = pl.year;
          this.input.price_sqm = pl.price_sqm;
          this.input.level = pl.level;
          this.input.comment = pl.remark;
          this.input.bts_distance = pl.bts_distance;
          this.input.mrt_distance = pl.mrt_distance;
          this.input.airportlink_distance = pl.airportlink_distance;
          this.input.rating = pl.rating;
          this.input.devlop_id = pl.developer_id;
          this.input.btsData = pl.btsData;
          this.input.mrtData = pl.mrtData;
          this.input.airportlinkData = pl.airportlinkData;
          this.input.meta = pl.meta
          this.input.address = pl.address
          this.input.province_id = pl.province_id
          this.input.amphure_id = pl.amphure_id
          this.input.tambon_id = pl.tambon_id
          this.input.zip_code = pl.zip_code
          this.input.youtube = pl.youtube
          this.input.total_building = pl.total_building
          this.input.total_unit = pl.total_unit
          this.input.tags_id = pl.tags_id || []
          
          //this.input.type_id = pl.type_id;
          this.input.is_active = pl.is_active?true:false;
          if(pl.type_id){
              this.input.type_id = {
                id : pl.id,
                //name : pl.type_name
              }
              if(this.types.length == 0){
                 const types = await axios.get('place/v1/type');
                 let type_data = types.data.data.filter(j => j.id == pl.type_id);
                 
                 if(type_data){
                 this.input.type_id =type_data[0];
                }
              }else{
                let type_data = this.types.filter(j => j.id == pl.type_id);
                 
                 if(type_data){
                 this.input.type_id =type_data[0];
                }

              }
              
          }
        
         // this.type_id = pl.type_name;
          this.input.created_by = pl.created_by;
          this.created_by = pl.created_name;
          /*if(pl.bts_id){
            if(this.bts.length == 0){
              let btses = await axios.get('transit/v1/listtype/bts');
              var bts = btses.data.data.filter(j => j.id == pl.bts_id);
              if(bts){
                this.input.bts_id.push(bts[0]);
              }
            }else{
              var bts = this.bts.filter(j => j.id == pl.bts_id);
                if(bts){
                  this.input.bts_id.push(bts[0]);
                }

            }

          }*/
          /*if(pl.mrt_id){
            if(this.mrt.length == 0){
              let mrts = await axios.get('transit/v1/listtype/mrt');
              var mrt = mrts.data.data.filter(j => j.id == pl.mrt_id);
              if(mrt){
                this.input.mrt_id.push(mrt[0]);
                }
            }else{
              var mrt = this.mrt.filter(j => j.id == pl.mrt_id);
                if(mrt){
                  this.input.mrt_id.push(mrt[0]);
                }

            }

          }*/
          if(pl.airport_id){
            
            if(this.airportlink.length == 0){
              let airports = await axios.get('transit/v1/listtype/airport');
              var airport = airports.data.data.filter(j => j.id == pl.airport_id);
              if(airport){
                this.input.airportlink_id =airport[0];
                }
            }else{
              var airport = this.airportlink.filter(j => j.id == pl.airport_id);
                if(airport){
                  this.input.airportlink_id =airport[0];
                }

            }

          }
         /* if(pl.zone_id){
            
            if(this.zone.length == 0){
              let queryParams1 = {
                  perpage: 1000,
                  offset:0
                
                }
              var data1 = JSON.stringify(queryParams1);
              let zones = await axios.post('zone/v1/lists',data1);
              var zone = zones.data.data.filter(j => j.id == pl.zone_id);
              if(zone){
                this.input.zone_id.push(zone[0]);
                }
            }else{
              var zone = this.zone.filter(j => j.id == pl.zone_id);
                if(zone){
                  this.input.zone_id.push(zone[0]);
                }

            }

          }*/
         
          if(pl.lat && pl.lng){
          this.center = [pl.lat,pl.lng]
          this.markerLatLng = [pl.lat,pl.lng]
          this.circle.center = [pl.lat,pl.lng]
        
        }

        this.onProvinceChange(this.input.province_id)
        this.onAmphureChange(this.input.amphure_id)
        this.onTambonChange(this.input.tambon_id)

      }
      
    },
    
    changelatlon(){
     
      //13.7314081,100.5392509
      if(this.input.lat && this.input.lon){
        this.center = [this.input.lat,this.input.lon]
        this.markerLatLng = [this.input.lat,this.input.lon]
        this.circle.center = [this.input.lat,this.input.lon]
        
      }

    },
    makeToast(variant = null,title,message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
    validationForm() {
      if (this.isSubmitting) return
      this.$refs.simpleRules.validate().then(success => {
        if (!success) return

        /*
         * ⚠️ ไม่มีพิกัด = บันทึกไม่ได้
         * โซน / สถานี / ที่อยู่ / สถานที่ใกล้เคียง คำนวณจากพิกัดทั้งหมด ถ้าปล่อยให้บันทึกโดยไม่มี
         * จะได้ place ที่ระบบคำนวณอะไรให้ไม่ได้เลย และต้องมาไล่แก้ทีหลัง
         */
        if (!this.hasCoord) {
          this.makeToast('danger', 'ต้องมีพิกัดก่อน', 'กรุณาใส่ Latitude และ Longitude ก่อนบันทึก')

          return
        }

        /* place ใหม่: กางผลที่คำนวณจากพิกัดให้ดูก่อนเสมอ แล้วค่อยบันทึกจากปุ่มใน popup */
        if (this.id === undefined && !this.geoBeforeSave) {
          this.checkCoord(true)

          return
        }

        this.saveForm()
      })
    },

    /** บันทึกจริง — แยกจาก validationForm เพื่อให้ popup เรียกต่อได้หลังคนกดยืนยัน */
    saveForm() {
      this.geoBeforeSave = false

      if (this.isSubmitting) return
      {
        {
          if(this.input.type_id && this.input.type_id.id){
            this.input.type_id = this.input.type_id.id;
          }

          var data = JSON.stringify(this.input);
          this.isSubmitting = true;
          if(this.id != undefined){
            axios.post(`place/v1/update/${this.id}`, data)
              .then(res => {
                if(!res.data.success){
                  this.makeToast('danger','Error 403',res.data.message);
                }else{
                  this.$router.push('/place/lists', () => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Done`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully updated as .`,
                        },
                      })
                  });
                }
              }).catch(error => {
                this.makeToast('danger','Error 403',error.response && error.response.data && error.response.data.message);
              }).finally(() => {
                this.isSubmitting = false;
              })
          }else{
            axios.post('place/v1/add',data)
              .then(res => {
                if(!res.data.success){
                  this.makeToast('danger','Error 403',res.data.message);
                }else{
                  this.$router.push('/place/lists', () => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Done`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully created.`,
                        },
                      })
                  });
                }
              }).catch(error => {
                  this.makeToast('danger','Error 403',error.response && error.response.data && error.response.data.message);
              }).finally(() => {
                this.isSubmitting = false;
              })
          }
        }
      }
    },
    fetchResults() {
      const { devlop_id } = this

      // One character matches ~6,000 users and the endpoint returns all of them; see user-autocomplete.js
      if(devlop_id && String(devlop_id).trim().length >= MIN_USER_KEYWORD){
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            searchUsers(devlop_id).then(data => {
                this.suggestions = []
              this.selected =null;
                this.suggestions.push({ name: 'dev', data: data })
            }).catch(error=>{
                console.log('error', error)
            })
          }, this.debounceMilliseconds)
      }else{
          this.suggestions = []
      }
    },
    
    filterResults(data, text, field) {
      return data.filter(item => {
        if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
          return item[field]
        }
        return false
      }).sort()
    },
    renderSuggestion(suggestion) {
      return suggestion.item.name
    },
    getSuggestionValue(suggestion) {
      const { name, item } = suggestion
     
      return name === 'hotels' ? item.title : item.name
    },
    fetchResultsType() {
      const { type_id } = this
      if(type_id){

      
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            var data = JSON.stringify({
                "keyword": type_id
                });
            const placePromise = axios.post('autocomplete/v1/placetype',data)
          
            

            Promise.all([placePromise]).then(values => {
                this.suggestionsType = []
              
                var data =  values[0].data.data;
                this.suggestionsType.push({ name: 'types', data: data })
              
              // this.suggestions.push();
            }).catch(error=>{
                console.log('error', error)
            })
          }, this.debounceMilliseconds)
      }else{
          this.suggestionsType = []
      }
    },
    
    filterResultsType(data, text, field) {
      return data.filter(item => {
        if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
          return item[field]
        }
        return false
      }).sort()
    },
    renderSuggestionType(suggestion) {
      return suggestion.item.name
    },
    getSuggestionValueType(suggestion) {
      const { name, item } = suggestion
     
      return name === 'hotels' ? item.title : item.name
    },
    fetchResultscb() {
      const { created_by } = this

      // One character matches ~6,000 users and the endpoint returns all of them; see user-autocomplete.js
      if(created_by && String(created_by).trim().length >= MIN_USER_KEYWORD){
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            searchUsers(created_by).then(data => {
                this.suggestionscb = []
                this.suggestionscb.push({ name: 'cb', data: data })
            }).catch(error=>{
                console.log('error', error)
            })
          }, this.debounceMilliseconds)
      }else{
          this.suggestionscb = []
      }
    },
    
    filterResultscb(data, text, field) {
      return data.filter(item => {
        if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
          return item[field]
        }
        return false
      }).sort()
    },
    renderSuggestioncb(suggestion) {
      return suggestion.item.name
    },
    getSuggestionValuecb(suggestion) {
      const { name, item } = suggestion
      
      return name === 'hotels' ? item.title : item.name
    },
    async addBTS() {
      const data = {
        transitId: this.bts_id,
        distance: this.distanceBts,
        duration: this.durationBts
      }

      this.input.btsData.push(data)
      this.bts_id = ''
      this.distanceBts = ''
      this.durationBts = ''
    },
    async removeBTS(index) {
      this.input.btsData.splice(index,1)
    },
    async addMRT() {
      const data = {
        transitId: this.mrt_id,
        distance: this.distanceMrt,
        duration: this.durationMrt
      }

      this.input.mrtData.push(data)
      this.mrt_id = ''
      this.distanceMrt = ''
      this.durationMrt = ''
    },
    async removeMRT(index) {
      this.input.mrtData.splice(index,1)
    },
    async addAirportlink() {
      const data = {
        transitId: this.airportlink_id,
        distance: this.distanceAirportlink,
        duration: this.durationAirportlink
      }

      this.input.airportlinkData.push(data)
      this.airportlink_id = ''
      this.distanceAirportlink = ''
      this.durationAirportlink = ''
    },
    async removeAirportlink(index) {
      this.input.airportlinkData.splice(index,1)
    },
    getNameBTS(btsId) {
      const found = this.bts.find((g) => g.id == btsId);
      return found ? found.name[this.currentLocale] : null;
    },
    getNameMRT(mrtId) {
      const found = this.mrt.find((g) => g.id == mrtId);
      return found ? found.name[this.currentLocale] : null;
    },
    getNameAirportlink(airId) {
      const found = this.airportlink.find((g) => g.id == airId);
      return found ? found.name[this.currentLocale] : null;
    },
  },
  setup() {
    const LANGUAGES_STORE_MODULE_NAME = "app-languages";
    if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
    onUnmounted(() => {
      if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
    });

    const langs = ref([]);

    const getLangs = ()=>{
      store.dispatch('app-languages/fetchData', { is_active: 1 })
        .then((res) => {
          if(res.data.success){
              langs.value = res.data.data;
          }  
        }
      )
    }

    getLangs()

    return {
      langs,
    }
  },
  watch: {
    provinceData(newVal) {
      if (newVal.length && !this.input.province_id) {
        this.input.province_id = newVal[0].id
      }
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-select.scss';
.vue2leaflet-map{
  &.leaflet-container{
    height: 350px;
  }
}

.facility-checkbox-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1rem;

  .custom-control-label {
    display: inline-flex;
    align-items: center;
  }
}

.facility-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  object-fit: contain;
}

@media (min-width: 768px) {
  .facility-checkbox-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1200px) {
  .facility-checkbox-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>